document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll(".flickity-slide");

  containers.forEach((container) => {
    let flkty = null;
    const slider = container.querySelector(".flickity-slide__container");
    const items = slider.querySelectorAll(".flickity-slide__item");
    const customDots = container.querySelector(".flickity-slide__dots");

    if (!slider || items.length < 2) {
      if (customDots) customDots.style.display = "none";
      return;
    }

    const GAP = 12;
    const MOBILE_WIDTH = 990;

    const shouldInitSlider = () => {
      let totalWidth = 0;
      items.forEach((item, index) => {
        totalWidth += item.offsetWidth;
        if (index !== items.length - 1) totalWidth += GAP;
      });

      return totalWidth > window.innerWidth;
    };

    const createCustomDots = (flktyInstance) => {
      if (!customDots) return;

      customDots.innerHTML = "";
      customDots.style.display = "flex";

      flktyInstance.cells.forEach((_, index) => {
        const dot = document.createElement("span");
        dot.className = "slider-dot";
        if (index === flktyInstance.selectedIndex)
          dot.classList.add("is-active");
        dot.addEventListener("click", () => flktyInstance.select(index));
        customDots.appendChild(dot);
      });

      flktyInstance.on("change", (index) => {
        const dots = customDots.querySelectorAll(".slider-dot");
        dots.forEach((dot, i) =>
          dot.classList.toggle("is-active", i === index)
        );
      });
    };

    const enableFlickity = () => {
      if (flkty) return;

      flkty = new Flickity(slider, {
        cellAlign: "left",
        contain: true,
        pageDots: false,
        wrapAround: false,
        lazyLoad: 2,
        prevNextButtons: false,
      });

      slider.classList.remove("not-has-slider");
      createCustomDots(flkty);
    };

    const destroyFlickity = (forceAddFallbackClass = false) => {
      if (flkty) {
        flkty.destroy();
        flkty = null;
        slider.classList.remove("flickity-enabled");

        if (customDots) {
          customDots.innerHTML = "";
          customDots.style.display = "none";
        }
      }

      if (forceAddFallbackClass) {
        requestAnimationFrame(() => {
          slider.classList.add("not-has-slider");
        });
      } else {
        slider.classList.remove("not-has-slider");
      }
    };

    const handleResize = () => {
      const isMobile = window.innerWidth < MOBILE_WIDTH;
      const canInit = shouldInitSlider();
      const shouldEnable = isMobile && canInit;

      if (shouldEnable) {
        enableFlickity();
      } else {
        const fallbackMode = isMobile && !canInit;
        destroyFlickity(fallbackMode);
      }
    };

    handleResize();

    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResize, 150);
    });
  });
});
